<div *ngIf="isUnseen" class="unseen-dot" title="Unseen issue - Updated: {{issue?.updatedAt}} | Viewed: {{issue?.lastViewed}}"></div>
